import {z} from 'zod';

export const dlqMessagesErrorResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  timestamp: z.string(),
});
